import React, { useEffect, useState } from 'react'
import { useSelector, shallowEqual } from 'react-redux'
import { Select } from './Form'
import * as api from '../../../requests.js'

export const ServerOptionsV2 = (props) => {
  const [params] = useState([])
  const [urlParams, setUrlParams] = useState([])
  const [options, setOptions] = useState(props.options || [{ value: '0', label: 'Loading...' }])
  const { fields } = useSelector((state) => state.wizard.wizard, shallowEqual)
  const [keys, setKeys] = useState(Object.keys(fields[props.fieldId]))
  const [dropdownApiCall, setDropdownApiCall] = useState('')
  const [disabled, setDisabled] = useState(props.disabled || false)
  const { wizard } = useSelector((state) => state.wizard, shallowEqual)

  useEffect(() => {
    setKeys(Object.keys(fields[props.fieldId]))
  }, [fields])

  useEffect(() => {
    for (let i = 0; i < keys.length; i++) {
      if (keys[i].includes('param_')) {
        params.push(fields[props.fieldId][keys[i]])
      }
    }

    let tryGetParams = undefined
    if (props.value) {
      if (typeof props.value === 'object' && !Array.isArray(props.value) && props.value !== null) {
        tryGetParams = props.value
      } else if (typeof props.value === 'string' && props.value !== 'default') {
        tryGetParams = JSON.parse(props.value)
      }
      if (tryGetParams && tryGetParams.params) {
        let paramKeys = Object.keys(tryGetParams.params)
        for (let i = 0; i < paramKeys.length; i++) {
          let targetParam = params.find((x) => x.value == paramKeys[i])
          if (targetParam) {
            targetParam.value = tryGetParams.params[paramKeys[i]]
          }
        }
      }
    }

    api.GET_DROP_DOWN_OPTION_BY_ID(fields[props.fieldId].optionsSource, (response) => {
      setDropdownApiCall(response.DropdownApiCall)
    })
  }, [])

  useEffect(() => {
    ;((options.length === 1 && options[0].label === 'Loading...') || !props.dontFetchInWizard) &&
      getOptions(fields)
  }, [dropdownApiCall])

  const readParameters = (parameter, fields) => {
    if (parameter.fromWizard) {
      return fields[parameter.value].value
    }
    if (parameter.value === 'businessTypeId')
      parameter.value =
        parseInt(wizard.meta.RECORD_TYPE_ID, 10) > 0 ? wizard.meta.RECORD_TYPE_ID : -1
    if (parameter.value === 'businessSubTypeId')
      parameter.value =
        parseInt(wizard.meta.RECORD_SUBTYPE_ID, 10) > 0 ? wizard.meta.RECORD_SUBTYPE_ID : -1
    return parameter.value
  }

  const getOptions = (fields) => {
    let currentParams = [...params]

    let tempUrlParams = ''
    for (let i = 0; i < currentParams.length; i++) {
      let value = `/${readParameters(currentParams[i], fields)}`
      tempUrlParams += value
    }

    if (urlParams !== tempUrlParams && dropdownApiCall) {
      setUrlParams(urlParams)
      api.GET(
        dropdownApiCall + tempUrlParams,
        (response) => {
          if (Array.isArray(response)) {
            const optionsWithEmptyOption = [
              { label: '[Select An Option]', value: 'default' },
              ...response,
            ]
            setFieldValue(
              optionsWithEmptyOption.find((res) => res.value === props.value)
                ? optionsWithEmptyOption.find((res) => res.value === props.value).value
                : { selectedIndex: optionsWithEmptyOption[0].value },
              null,
              optionsWithEmptyOption.find((res) => res.value === props.value)
                ? optionsWithEmptyOption.find((res) => res.value === props.value).value
                : { selectedIndex: optionsWithEmptyOption[0].value }
            )
            setOptions(optionsWithEmptyOption)

            props.onChange(props.value, null, {
              options: optionsWithEmptyOption,
            })
          } else {
            console.error(
              'Error loading options. If the options shouldn\'t be fetched, check the "Don\'t update options on wizard load" v2 field attribute in the forms manager.'
            )
            setOptions([{ label: 'Error loading options', value: 0 }])
            setDisabled(true)
          }
        },
        (error) => {
          console.error(
            'Error loading options. If the options shouldn\'t be fetched, check the "Don\'t update options on wizard load" v2 field attribute in the forms manager.'
          )
          setOptions([{ label: 'Error loading options', value: 0 }])
          setDisabled(true)
          console.error(error)
        }
      )
    }
  }
  const setFieldValue = (value, e, payload) => {
    if (value !== props.value) {
      props.onChange(value, e, {
        ...payload,
        selectedOptionLabel: options.find((option) => option.value == value)
          ? options.find((option) => option.value == value).label
          : undefined,
      })
    }
  }

  return (
    <Select
      width={props.width}
      onChange={setFieldValue}
      options={options}
      value={props.value}
      disabled={disabled}
      required={props.required}
    />
  )
}
export default ServerOptionsV2
